<template>
    <div class="dintica-world-container">

        <div class="top">
            <img src="../../assets/imgs/general/overlay-shape.png" alt="" class="w-100">
        </div>

        <div id="tuti_world" class="container pt-5 pb-5">


            <div class="d-flex flex-column w-md-75 justify-content-center mx-auto text-center mt-5 my-md-5">
                <h2>Lumea lui Tuti</h2>

                <p class="pt-3">
                    Un tărâm magic și frumos, unde toți dințișorii trăiesc în armonie și prietenie jucându-se și
                    învățând împreună cum să fie sănătoși. Este un loc așa de distractiv încât trebuie să îi faci o
                    vizită!</p>
            </div>

            <div class="d-flex flex-column flex-md-row my-md-5 pt-md-5" id="friends">

                <div class="w-md-50 order-2 order-md-1 text-center my-auto img-container">
                    <img src="../../assets/imgs/landing/friends-dintica.png" alt="" id="preview" class="img-fluid">
                </div>

                <div class="d-flex flex-column pt-5 w-md-50 order-1 order-md-2 pl-md-3">
                    <h2>
                        Prietenii lui Tuti
                    </h2>
                    <p class="pt-3">
                        Tuti este un dințișor foarte prietenos. Nu-i de mirare că și-a făcut o mulțime de prieteni în
                        drumețiile lui. Zâna Măseluță, Lăpturoșii dar și Dulciurica sunt personaje pe care le vei
                        întâlni în fiecare vizită pe care o vei face în lumea magică a lui Tuti, Dințișorul Zurliu.
                    </p>

                    <div class="d-flex flex-row flex-wrap justify-content-center justify-content-md-start slider"
                         id="friends-carousel">
                        <div class="item">
                            <div class="friend mx-2 dintica" id="dintica">
                                <img src="../../assets/imgs/landing/friends-dintica-sm.png" alt=""
                                     class="img-fluid mx-auto">
                                <h6 class="text-center active">Tuti</h6>
                            </div>
                        </div>
                        <div class="item">
                            <div class="friend mx-2 zana" id="zana">
                                <img src="../../assets/imgs/landing/friends-zana-sm.png" alt=""
                                     class="img-fluid mx-auto">
                                <h6 class="text-center">Zâna<br>Măseluță</h6>
                            </div>
                        </div>
                        <div class="item">
                            <div class="friend mx-2 caria" id="caria">
                                <img src="../../assets/imgs/landing/friends-caria-sm.png" alt=""
                                     class="img-fluid mx-auto">
                                <h6 class="text-center">Dulciurica</h6>
                            </div>
                        </div>
                        <div class="item">
                            <div class="friend mx-2 lopatari" id="lopatari">
                                <img src="../../assets/imgs/landing/friends-lopatari-sm.png" alt=""
                                     class="img-fluid mx-auto">
                                <h6 class="text-center">Lăpturoșii</h6>
                            </div>
                        </div>
                    </div>

                    <div id="friends-carousel-mobile" class="d-flex flex-row justify-content-center slider">
                        <div class="item">
                            <div class="friend mx-2 dintica" id="dintica">
                                <img src="../../assets/imgs/landing/friends-dintica.png" alt=""
                                     class="img-fluid mx-auto">
                                <h6 class="text-center active">Tuti</h6>
                            </div>
                        </div>
                        <div class="item">
                            <div class="friend mx-2 zana" id="zana">
                                <img src="../../assets/imgs/landing/friends-zana.png" alt="" class="img-fluid mx-auto">
                                <h6 class="text-center active">Zâna Măseluță</h6>
                            </div>
                        </div>
                        <div class="item">
                            <div class="friend mx-2 caria" id="caria">
                                <img src="../../assets/imgs/landing/friends-caria.png" alt="" class="img-fluid mx-auto">
                                <h6 class="text-center active">Dulciurica</h6>
                            </div>
                        </div>
                        <div class="item">
                            <div class="friend mx-2 lopatari" id="lopatari">
                                <img src="../../assets/imgs/landing/friends-lopatari.png" alt=""
                                     class="img-fluid mx-auto">
                                <h6 class="text-center active">Lăpturoșii</h6>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <div class="d-flex flex-column pt-5 my-md-5" id="planets">

                <h2>
                    Planetele din lume
                </h2>

                <div id="planets-carousel" class="slider">

                    <div class="d-flex flex-column flex-md-row justify-content-between">
                        <div class="d-flex flex-column w-md-50 my-auto pt-3 pl-1">
                            <h6>
                                Planeta Zânei Dulciurica
                            </h6>
                            <p class="pt-2">
                                Chiar și un drum scurt prin Planeta Zânei Dulciurica îți va dezvălui priveliști
                                nemaivăzute : copaci de acadele, munți de înghețată, râuri colorate de suc acidulat și
                                multe altele. Dar pe cât de apetisante, pe atât de periculoase sunt pentru dințișori:
                                aici e casa Dulciuricăi, cea care ademenește dințișorii sănătoși cu dulciuri, apoi le ia
                                strălucirea și pune stăpânire pe ei. Trebuie să stăm cu ochii în patru aici!
                            </p>
                        </div>
                        <div class="w-md-50 my-auto">
                            <img src="../../assets/imgs/landing/planeta-dulciurilor.png" alt=""
                                 class="img-fluid ml-auto">
                        </div>
                    </div>

                    <div class="d-flex flex-column flex-md-row justify-content-between">
                        <div class="d-flex flex-column w-md-50 my-auto pt-3 pl-1">
                            <h6>
                                Planeta Periuțelor
                            </h6>
                            <p class="pt-2">
                                Ce frumoasă este această planetă: dealuri și văi nesfârșite, întinse cât vezi cu ochii,
                                toate acoperite de o pătură de păduri luxuriante. Dar dacă te apropii, vei vedea ceva și
                                mai surprinzător: copacii sunt de fapt periuțe de spălat dințișorii. Ce imagine
                                minunată, cum bat ele în vânt și li se unduiesc perișorii că într-un dans continuu. Da,
                                aceasta e o planetă în care ne așteaptă multe aventuri!
                            </p>
                        </div>
                        <div class="w-md-50 my-auto">
                            <img src="../../assets/imgs/landing/planeta-periutelor.png" alt=""
                                 class="img-fluid ml-auto">
                        </div>
                    </div>

                    <div class="d-flex flex-column flex-md-row justify-content-between">
                        <div class="d-flex flex-column w-md-50 my-auto pt-3 pl-1">
                            <h6>
                                Planeta Zânei Măseluță
                            </h6>
                            <p class="pt-2">
                                Un loc magic, plin de farmec și de încântare, aceasta este Planeta Zânei Măseluță. Aici
                                întâlnim Regatul unde domnește chiar ea, Zâna Măseluță, cea care are grijă de dințișorii
                                albi învățându-i cum să se păstreze sănătoși și strălucitori, și care îi ajută să
                                trăiască fericiți în armonie. E un tărâm frumos că un vis și distractiv că un joc
                                neîncetat. Aici chiar merită să ne petrecem o sută de vacanțe și jumătate!
                            </p>
                        </div>
                        <div class="w-md-50 my-auto">
                            <img src="../../assets/imgs/landing/planeta-zana-merciluta.png" alt=""
                                 class="img-fluid ml-auto">
                        </div>
                    </div>
                </div>

            </div>

        </div>

    </div>
</template>

<script>
    export default {
        name: "DinticaWorld",
        mounted() {
            const $ = window.$;

            $(document).ready(function () {
                $('.friend').click(function (event) {
                    console.log('click', event);
                    $('#friends h6').removeClass('active');
                    let target;
                    if (event.currentTarget.id) {
                        target = event.currentTarget.id;
                    } else {
                        target = event.currentTarget.classList[2];
                    }
                    // let imgSource = require('../../assets/imgs/landing/friends-' + target + '.png');
                    // $('#preview').attr('src', imgSource);
                    // $('#' + target + ' h6').addClass('active');


                    $("#preview").fadeOut(200, function () {
                        let imgSource = require('../../assets/imgs/landing/friends-' + target + '.png');
                        $('#preview').attr('src', imgSource);
                        $('#' + target + ' h6').addClass('active');
                        $('#preview').fadeIn(300);
                    });
                });
            });

            $(window).resize(function () {
                initializeCarousels();
            });

            $(document).ready(function () {
                initializeCarousels();
            });

            function initializeCarousels() {
                setTimeout(function () {
                    // $(".slider").not('.slick-initialized').slick();

                    $('#friends-carousel-mobile').not('.slick-initialized').slick({
                        dots: false,
                        infinite: true,
                        speed: 500,
                        fade: true,
                        cssEase: 'linear'
                    });
                    $('#friends-carousel-mobile').slick('refresh');

                    $('#planets-carousel').not('.slick-initialized').slick({
                        dots: false,
                        infinite: true,
                        speed: 500,
                    });

                    $('#friends-carousel').not('.slick-initialized').slick({
                        dots: false,
                        infinite: true,
                        speed: 500,
                        slidesToShow: 4,
                        responsive: [
                            {
                                breakpoint: 1200,
                                settings: {
                                    slidesToShow: 3,
                                    slidesToScroll: 1,
                                    infinite: true,
                                    dots: true
                                }
                            },
                            {
                                breakpoint: 992,
                                settings: {
                                    slidesToShow: 2,
                                    slidesToScroll: 1,
                                    infinite: true,
                                    dots: true
                                }
                            },
                            {
                                breakpoint: 768,
                                settings: {
                                    slidesToShow: 3,
                                    slidesToScroll: 1,
                                    infinite: true,
                                    dots: true
                                }
                            },
                            {
                                breakpoint: 600,
                                settings: {
                                    slidesToShow: 2,
                                    slidesToScroll: 1,
                                    infinite: true,
                                    dots: true
                                }
                            },
                            {
                                breakpoint: 400,
                                settings: {
                                    slidesToShow: 1,
                                    slidesToScroll: 1,
                                    infinite: true,
                                    dots: true
                                }
                            }
                        ]
                    });
                    $('#friends-carousel').slick('refresh');
                }, 305);
            }
        },
    }
</script>
